<template>
  <div class="create" @keyup.13="submit">
    <mu-dialog title="新增转账" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="money" label="金额">
          <mu-text-field v-model="form.money"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        money: '',
        remark: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.transfer.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                money: '',
                remark: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.create {
}
</style>



// WEBPACK FOOTER //
// src/views/transfer/create.vue